import * as React from "react"
import { useTranslation } from "react-i18next"

import StatefulField from "shared/components/StatefulField"
import useEditor from "shared/hooks/useEditor"
import { IDiscount } from "shared/hubrise/models"
import * as Discount from "shared/hubrise/utils/Discount"

import { StyledPricing, Effect, Value } from "./Styles"

const Pricing = ({ discount }: { discount: IDiscount }): JSX.Element => {
  const { t } = useTranslation()
  const {
    editor,
    catalog: { currency },
  } = useEditor()

  return (
    <StyledPricing>
      <Effect>
        <StatefulField.Select
          name="discount-pricing-effect"
          initialValue={[discount.pricingEffect]}
          label={t("charge.pricing_effect.label")}
          withMargin
          onChange={(value) => {
            const pricingEffect = value[0] as IDiscount["pricingEffect"]
            const pricing = Discount.switchPricingEffect(discount, pricingEffect, currency)
            editor.discount.updatePricing(discount.id, pricing)
          }}
          options={[
            { label: t("charge.pricing_effect.price_off"), value: "price_off" },
            { label: t("charge.pricing_effect.percentage_off"), value: "percentage_off" },
          ]}
          debounce={false}
          searchable={false}
        />
      </Effect>

      <Value>
        {discount.pricingEffect === "price_off" ? (
          <StatefulField.MoneyInput
            name="discount-pricing-value"
            initialValue={discount.pricingValue}
            label={t("charge.price.price_off")}
            withMargin
            onChange={(value) => {
              if (value) editor.discount.update(discount.id, "pricingValue", value)
            }}
            validate={(value) => (value === null ? t("validations.not_empty") : undefined)}
            currency={currency}
          />
        ) : (
          <StatefulField.Input
            name="discount-pricing-value"
            initialValue={discount.pricingValue.toString()}
            label={t("charge.price.percentage_off")}
            withMargin
            onChange={(value) => {
              const numericValue = parseFloat(value)
              if (!isNaN(numericValue)) editor.discount.update(discount.id, "pricingValue", numericValue)
            }}
            validate={(value) => (value.length === 0 ? t("validations.not_empty") : undefined)}
            filter={/^\d*(\.\d{0,2})?$/}
            prefix="%"
          />
        )}
      </Value>
    </StyledPricing>
  )
}

export default Pricing
